export enum CurrentUserGraphQLActionType {
  profile = 'profile',
  selectCurrentCompany = 'selectCurrentCompany',
  updateLoginEmail = 'updateLoginEmail',
  updateLoginPassword = 'updateLoginPassword',
  updateProfile = 'updateProfile'
}
